import { HYDRATE } from 'next-redux-wrapper';
import { AnyAction } from 'redux';

// The next-redux-wrapper packages states that the HYDRATE action must be implemented
// but I don't think we need it because all of our Redux state so far is client-only.
// I have never been able to get this action to fire.
// As a precaution, I have the action returning the client state intact.
const hydrationReducer = (state: any = {}, action: AnyAction) => {
  switch (action?.type) {
    case HYDRATE:
      // https://github.com/kirill-konshin/next-redux-wrapper#state-reconciliation-during-hydration
      // 'state' is existing client state
      // 'payload' is state at time of GSSP
      console.log('dpb HYDRATE', state, action.payload);
      return { ...(action?.payload ?? {}), ...state };
    default:
      return state;
  }
};

export default hydrationReducer;
